import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export enum BootstrapPhase {
  IDLE = 'idle',
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  READY = 'ready',
  NO_USER = 'no-user', // completed, but no authorized user
  ERROR = 'error',
}

export const useBootstrapStore = defineStore('bootstrapStore', () => {
  const phase = ref<BootstrapPhase>(BootstrapPhase.IDLE);
  const error = ref<unknown>(null);

  const isReady = computed(() => phase.value === BootstrapPhase.READY);

  const isBootstrapping = computed(
    () => phase.value !== BootstrapPhase.READY
      && phase.value !== BootstrapPhase.NO_USER
      && phase.value !== BootstrapPhase.ERROR,
  );

  function begin(): void {
    phase.value = BootstrapPhase.INITIALIZING;
    error.value = null;
  }

  function enterLoading(): void {
    phase.value = BootstrapPhase.LOADING;
  }

  function markReady(): void {
    phase.value = BootstrapPhase.READY;
  }

  function markNoUser(): void {
    phase.value = BootstrapPhase.NO_USER;
  }

  function fail(bootstrapError: unknown): void {
    error.value = bootstrapError;
    phase.value = BootstrapPhase.ERROR;
  }

  return {
    phase,
    error,
    isReady,
    isBootstrapping,

    begin,
    enterLoading,
    markReady,
    markNoUser,
    fail,
  };
});
